import React, { useContext } from 'react';
import '../styles/PageSidebar.css';
import AppContext from './context/AppContext';
import PageSidebarBrandList from './PageSidebarBrandList';
import PageSidebarCategoryList from './PageSidebarCategoryList';


const PageSidebar = () => {
    const { appContext } = useContext(AppContext);
    const appConfig = appContext.config.themeConfig;

    return (
        <div
            className={'page-sidebar--container'}
        >
            <div
                className={'page-sidebar--section'}
            >
                <h3
                    className={'page-sidebar--heading'}
                >
                    CATEGORIES
                </h3>
                <PageSidebarCategoryList />
            </div>
            <div
                className={'page-sidebar--section'}
            >
                <h3
                    className={'page-sidebar--heading'}
                >
                    BRANDS
                </h3>
                <PageSidebarBrandList />
            </div>
            <div>
                <img
                    style={{
                        width: '100%',
                        height: 'auto',
                        marginTop: '20px'
                    }}
                    src={appConfig.collectionSideBarBannerImage}
                    alt={'Sidebar Banner'}
                />
            </div>
        </div>
    );
};

export default PageSidebar;
